import styles from './AnalysisForm.module.css';

interface OcrCounterProps {
	current: number;
	total: number;
	progress: number;
	label?: string;
}

export const OcrCounter = ({ current, total, progress, label = 'Análises do laudo' }: OcrCounterProps) => (
	<div className={styles.ocrCounter}>
		<span className={styles.ocrCounterLabel}>{label}</span>
		<span className={styles.ocrCounterValue}>
			{current}/{total}
		</span>
		<div className={styles.ocrCounterTrack}>
			<div className={styles.ocrCounterFill} style={{ width: `${progress}%` }} />
		</div>
	</div>
);
